import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import GeneralContext from '../context/GeneralContext/GeneralContext';
import { Result } from 'antd';

/**
 * Guard de rota por papel.
 * Renderiza o children apenas se o usuário logado tiver um dos papéis permitidos.
 * Caso contrário, exibe uma tela de "sem permissão" (não redireciona para /login
 * porque o usuário está autenticado, apenas sem acesso àquela rota).
 *
 * @param {number[]} allowedRoles códigos de EUserTypes permitidos
 * @param {React.ReactNode} children conteúdo da rota
 */
const RoleRoute = ({ allowedRoles = [], children }) => {
  const { loggedUser } = useContext(GeneralContext);

  if (!loggedUser) {
    return <Navigate to="/login" replace />;
  }

  const hasAccess = allowedRoles.includes(loggedUser.type);

  if (!hasAccess) {
    return (
      <Result
        status="403"
        title="Sem permissão"
        subTitle="Você não tem acesso a esta área."
      />
    );
  }

  return children;
};

export default RoleRoute;
